import React from 'react';
import {Field} from 'formik';  

function NumberInputItem(props) {
 
    return (
         <p>  
        <label htmlFor ={props.name}>{props.display}</label>
        <Field type="number" id={props.name} name={props.name}  min="0" 
        />
         </p>   
    );
}

export default NumberInputItem;